import { InjectionToken } from "@angular/core";

export const GOOGLE_API_KEY = new InjectionToken<string>('GOOGLE_API_KEY');
export const GOOGLE_GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/';
export const GOOGLE_GEOCODE_DEFAULT_LANGUAGE = 'en';
